import React from 'react';
import useOrganization from '../../../hooks/use-organization';
import AddAdmin from './admin-add';
import OrganizationAddAdmin from '../organization/organization-admin-add';

// Dispatches the "Add Admin" route between the system and organization flows,
// mirroring `settings/index.tsx`. Organization mode is keyed on the
// `organizationId` query param (via `useOrganization`).
const AddAdminIndex: React.FC<any> = (props) => {
  const organizationInfo = useOrganization();

  return Boolean(organizationInfo?.id) ? (
    <OrganizationAddAdmin />
  ) : (
    <AddAdmin {...props} />
  );
};

export default AddAdminIndex;
